'use client';

import { ReactNode, useEffect } from 'react';

const HeaderClient = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    // Adding a delay to ensure elements are loaded
    setTimeout(() => {
      const menu = document.querySelector('.menu-mobile') as HTMLElement;
      const menuSection = menu?.querySelector('.menu-section') as HTMLElement;
      const menuArrow = document?.querySelector(
        '.menu-mobile-arrow'
      ) as HTMLElement;
      const menuClosed = document?.querySelector(
        '.menu-mobile-close'
      ) as HTMLElement;
      const menuTrigger = document.querySelector(
        '.menu-mobile-trigger'
      ) as HTMLElement;
      const menuOverlay = document.querySelector(
        '.header__overlay'
      ) as HTMLElement;
      let subMenu: HTMLElement | null = null;

      // Ensure elements exist before adding event listeners
      if (
        menu &&
        menuSection &&
        menuArrow &&
        menuClosed &&
        menuTrigger &&
        menuOverlay
      ) {
        menuSection.addEventListener('click', (e) => {
          if (!menu.classList.contains('active')) {
            return;
          }

          const target = e.target as HTMLElement;
          if (target.closest('.menu-item-has-children')) {
            const hasChildren = target.closest(
              '.menu-item-has-children'
            ) as HTMLElement;
            showSubMenu(hasChildren);
          }
        });

        menuArrow.addEventListener('click', () => {
          hideSubMenu();
        });

        menuTrigger.addEventListener('click', () => {
          toggleMenu();
        });

        menuClosed.addEventListener('click', () => {
          toggleMenu();
        });

        menuOverlay.addEventListener('click', () => {
          toggleMenu();
        });
      } else {
        console.error('One or more elements are null:', {
          menu,
          menuSection,
          menuArrow,
          menuClosed,
          menuTrigger,
          menuOverlay,
        });
      }

      function toggleMenu() {
        if (menu) {
          menu.classList.toggle('active');
        }
        if (menuOverlay) {
          menuOverlay.classList.toggle('active');
        }
      }

      function showSubMenu(hasChildren: HTMLElement) {
        subMenu = hasChildren.querySelector('.submenu') as HTMLElement;
        if (subMenu) {
          subMenu.classList.add('active');
          subMenu.style.animation = 'slideLeft 0.5s ease forwards';
          const menuTitle =
            hasChildren.querySelector('i,svg')?.parentNode?.childNodes[0]
              ?.textContent || '';
          if (menu) {
            menu.querySelector('.menu-mobile-title')!.innerHTML =
              menuTitle || 'Title';
            menu.querySelector('.menu-mobile-header')!.classList.add('active');
          }
        }
      }

      function hideSubMenu() {
        if (subMenu) {
          subMenu.style.animation = 'slideRight 0.5s ease forwards';
          setTimeout(() => {
            subMenu?.classList.remove('active');
          }, 300);

          if (menu) {
            menu.querySelector('.menu-mobile-title')!.innerHTML = '';
            menu
              .querySelector('.menu-mobile-header')!
              .classList.remove('active');
          }
        }
      }

      window.onresize = () => {
        if (window.innerWidth > 1199) {
          if (menu && menu.classList.contains('active')) {
            toggleMenu();
          }
        }
      };

      function makeHeaderSticky() {
        const headerBottom = document.querySelector('.header') as HTMLElement;
        if (headerBottom) {
          const headerBottomOffset =
            headerBottom.offsetTop + headerBottom.offsetHeight;

          window.addEventListener('scroll', () => {
            if (window.pageYOffset >= headerBottomOffset) {
              headerBottom.classList.add('fixed');
            } else {
              headerBottom.classList.remove('fixed');
            }
          });
        }
      }

      makeHeaderSticky();
    }, 1000); // Delay of 1 second to make sure elements are available

    /*================<< Header menu js end here>>====================*/

    /*================<< Searchbar js start here>>====================*/

    document.addEventListener('DOMContentLoaded', function () {
      const searchIcon = document.querySelector('.search-icon') as HTMLElement;
      const searchForm = document.querySelector('.trk-search') as HTMLElement;
      const overlay = document.querySelector(
        '.trk-search__overlay'
      ) as HTMLElement;

      if (searchIcon && searchForm && overlay) {
        searchIcon.addEventListener('click', function () {
          searchForm.classList.add('active');
          if (overlay) overlay.style.display = 'block';
        });

        if (overlay) {
          overlay.addEventListener('click', function () {
            searchForm.classList.remove('active');
            overlay.style.display = 'none';
          });
        }

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && searchForm.classList.contains('active')) {
            searchForm.classList.remove('active');
            overlay.style.display = 'none';
          }
        });
      }
    });

    /*================<< Searchbar js end here>>====================*/
  }, []); // Empty dependency array ensures this runs only once after the first render

  return <>{children}</>;
};

export default HeaderClient;
